// Changing a route will lead to temporary 404-errors for the mechanics since
// they tend to use old tabs. Change only if it's necessary.
export enum Route {
  HEALTH__CHECK = "health", // GET

  E2E__SEED = "e2e/seed", // POST
  E2E__SEED_INSPECTION_JOB = "e2e/seed-inspection-job", // POST
  E2E__SEED_REPEAT_BIKE_INSPECTION_JOB = "e2e/seed-repeat-bike-inspection-job", // POST
  E2E__SET_OPENING_HOURS = "e2e/set-opening-hours", // POST
  E2E__SET_SLOTS_OVERRIDE = "e2e/set-slots-override", // POST
  E2E__VERIFICATION_CODE = "e2e/verification-code", // GET
  E2E__SET_PACKAGE_DEFAULT_DISCOUNT = "e2e/set-package-default-discount", // POST
  E2E__SET_PACKAGE_MATERIAL_COST = "e2e/set-package-material-cost", // POST
  E2E__SEED_WORK_ORDER_JOB = "e2e/seed-work-order-job", // POST
  E2E__SEED_JOB_WITH_TODO_DELIVERY = "e2e/seed-job-with-todo-delivery", // POST
  E2E__DELETE_JOB = "e2e/delete-job", // POST
  E2E__SEED_ADDON_ORDER_JOB = "e2e/seed-addon-order-job", // POST
  E2E__SEED_ADDON_ORDER_JOB_WITH_EXISTING_PACKAGE = "e2e/seed-addon-order-job-with-existing-package", // POST
  E2E__ACTIVATE_STANDARD_FEES = "e2e/activate-standard-fees", // POST
  E2E__SEED_JOB_WITH_FEES = "e2e/seed-job-with-fees", // POST
  E2E__SEED_PROPOSAL_SENT_JOB = "e2e/seed-proposal-sent-job", // POST
  E2E__SEED_PROPOSAL_WITH_CHANGED_RECEPTION_ACTION = "e2e/seed-proposal-with-changed-reception-action", // POST
  E2E__SEED_PROPOSAL_WITH_LOCKED_PACKAGE = "e2e/seed-proposal-with-locked-package", // POST
  E2E__SEED_BULK_COLLECTED_JOBS = "e2e/seed-bulk-collected-jobs", // POST
  E2E__SET_STORE_LOCATION = "e2e/set-store-location", // POST

  EMERGENCY_SERVICE__GET_SETTINGS = "emergency-service/settings/store/{storeId}", // GET
  EMERGENCY_SERVICE__TOGGLE = "emergency-service/toggle/store/{storeId}", // PATCH
  EMERGENCY_SERVICE__SAVE = "emergency-service/store/{storeId}", // POST
  EMERGENCY_SERVICE__FIND_ALL = "emergency-service/store/{storeId}", // GET

  ELECTRIC_SYSTEM__FIND_ALL = "electric-system", // GET
  SUPPORTED_ELECTRIC_SYSTEM__FIND_ALL = "supported-electric-system/store/{storeId}", // GET
  SUPPORTED_ELECTRIC_SYSTEM__ADD = "supported-electric-system/store/{storeId}/system/{systemId}", // POST
  SUPPORTED_ELECTRIC_SYSTEM__DELETE = "supported-electric-system/store/{storeId}/system/{systemId}", // DELETE

  LEASING_COMPANY__FIND_ALL = "leasing-company", // GET
  SUPPORTED_LEASING_COMPANY__FIND_ALL = "supported-leasing-company/store/{storeId}", // GET
  SUPPORTED_LEASING_COMPANY__ADD = "supported-leasing-company/store/{storeId}/company/{companyId}", // POST
  SUPPORTED_LEASING_COMPANY__DELETE = "supported-leasing-company/store/{storeId}/company/{companyId}", // DELETE

  SUPPORTED_BIKE_TYPE__FIND_ALL = "supported-bike-type/store/{storeId}", // GET
  SUPPORTED_BIKE_TYPE__ADD = "supported-bike-type/store/{storeId}", // POST
  SUPPORTED_BIKE_TYPE__DELETE = "supported-bike-type/store/{storeId}/bike-type/{bikeType}", // DELETE

  CUSTOM_BIKE_TYPE__FIND_ALL = "custom-bike-type/store/{storeId}", // GET
  CUSTOM_BIKE_TYPE__ADD = "custom-bike-type/store/{storeId}", // POST
  CUSTOM_BIKE_TYPE__DELETE = "custom-bike-type/store/{storeId}/{customBikeTypeId}", // DELETE

  BIKE_BRAND_PARTNERSHIP__FIND_ALL = "bike-brand-partnership/store/{storeId}", // GET
  BIKE_BRAND_PARTNERSHIP__ADD = "bike-brand-partnership/store/{storeId}/brand/{brandId}", // POST
  BIKE_BRAND_PARTNERSHIP__REMOVE = "bike-brand-partnership/store/{storeId}/brand/{brandId}", // DELETE

  BOOKING_RULES__GET_BOOKABLE_SLOTS = "booking-rules/bookable-slots/store/{storeId}", // GET
  BOOKING_RULES__GET_BOOKABLE_SLOTS_OVERRIDES = "booking-rules/bookable-slots-override/store/{storeId}", // GET
  BOOKING_RULES__GET_LEAD_TIME = "booking-rules/lead-time/store/{storeId}", // GET
  BOOKING_RULES__UPSERT_BOOKABLE_SLOTS = "booking-rules/bookable-slots/store/{storeId}", // PATCH
  BOOKING_RULES__UPSERT_BOOKABLE_SLOTS_OVERRIDE = "booking-rules/bookable-slots-override/store/{storeId}", // PATCH
  BOOKING_RULES__DELETE_BOOKABLE_SLOTS_OVERRIDE = "booking-rules/bookable-slots-override/store/{storeId}/date/{dateKey}", // DELETE
  BOOKING_RULES__SET_LEAD_TIME = "booking-rules/lead-time/store/{storeId}", // PUT
  BOOKING_RULES__GET_CARGO_BIKE_LIMIT = "booking-rules/cargo-bike-limit/store/{storeId}", // GET
  BOOKING_RULES__SET_CARGO_BIKE_LIMIT = "booking-rules/cargo-bike-limit/store/{storeId}", // PUT
  BOOKING_RULES__UPSERT_BOOKABLE_SLOTS_OVERRIDES_BATCH = "booking-rules/bookable-slots-overrides-batch/store/{storeId}", // PATCH
  BOOKING_RULES__DELETE_BOOKABLE_SLOTS_OVERRIDES_BATCH = "booking-rules/bookable-slots-overrides-batch/store/{storeId}", // DELETE

  INTERNAL_NOTE__SAVE = "internal-note", // PUT
  INTERNAL_NOTE__FIND_MOST_RECENT = "internal-note/job/{jobId}", // GET

  CUSTOMER_COMMENT__SAVE = "customer-comment", // PUT
  CUSTOMER_COMMENT__FIND_MOST_RECENT = "customer-comment/job/{jobId}", // GET

  CUSTOMER_REVIEW__SAVE = "customer-review/save", // PUT
  CUSTOMER_REVIEW__RESPOND = "customer-review/job/{jobId}/respond", // POST
  CUSTOMER_REVIEW__FIND_ALL_BY_STORE = "customer-review/store/{storeId}", // GET
  CUSTOMER_REVIEW__FIND_ALL_BY_STORE_FOR_MARKETPLACE = "customer-review/marketplace/store/{storeId}", // GET
  CUSTOMER_REVIEW__FIND_PUBLIC_BY_STORE = "customer-review/public/store/{storeId}", // GET
  CUSTOMER_REVIEW__FIND_ONE_BY_JOB = "customer-review/job/{jobId}", // GET
  CUSTOMER_REVIEW__PROMPT = "customer-review/prompt", // POST
  CUSTOMER_REVIEW__STATS = "customer-review/stats/store/{storeId}", // GET
  CUSTOMER_REVIEW__PUBLIC_STATS = "customer-review/public/stats/store/{storeId}", // GET

  TRENDS__ALL = "trends/all/store/{storeId}/time-unit/{timeUnit}/end-date/{endDate}", // GET

  STATS__ALL = "stats/all/store/{storeId}/start-date/{startDate}/end-date/{endDate}", // GET
  STATS__ADDON_CARD = "stats/addon-card/store/{storeId}/start-date/{startDate}/end-date/{endDate}", // GET
  STATS__LEAD_TIME_STANDINGS = "stats/lead-time-standings/store/{storeId}/start-date/{startDate}/end-date/{endDate}", // GET
  STATS__ACHIEVEMENTS = "stats/achievements/store/{storeId}/year/{year}", // GET
  STATS__ACHIEVEMENT_REVIEWS = "stats/achievements/store/{storeId}/year/{year}/reviews", // GET (?month=&mechanicId=)
  STATS__UNSEEN_MILESTONES = "stats/achievements/store/{storeId}/unseen-milestones", // GET
  STATS__MARK_MILESTONES_SEEN = "stats/achievements/store/{storeId}/unseen-milestones/seen", // PATCH
  STATS__MECHANIC_ACHIEVEMENTS = "stats/achievements/store/{storeId}/year/{year}/mechanic/{mechanicId}", // GET
  STATS__BIKE_STORE_CAPACITY = "stats/bike-store-capacity/store/{storeId}", // GET
  STATS__OVERVIEW_LATE_COUNTS = "stats/overview-late-counts/store/{storeId}", // GET
  STATS__PRICE_SIMULATION = "stats/price-simulation/store/{storeId}", // GET
  STATS__INSPECTION_SIMULATION = "stats/inspection-simulation/store/{storeId}", // GET
  STATS__SIMULATION_SETTINGS = "stats/simulation-settings/store/{storeId}", // GET
  STATS__UPDATE_SIMULATION_SETTINGS = "stats/simulation-settings/store/{storeId}", // PUT
  STATS__COMPUTE_SIMULATION_PROFIT_SHARES = "stats/simulation-profit-shares/store/{storeId}", // POST
  STATS__ALFRED_IMPACT = "stats/alfred-impact/store/{storeId}", // GET
  STATS__UPDATE_ALFRED_IMPACT_BASELINE = "stats/alfred-impact/store/{storeId}/baseline", // PUT
  // Admin: stats and trends combined across several ALFRED stores (?storeIds=a,b)
  STATS__ADMIN_STORES = "stats/admin/stores", // GET
  STATS__ADMIN_TASK_EFFORT = "stats/admin/task-effort", // GET (?storeIds=a,b&days=30)
  STATS__ADMIN_STORE_COLLECTIONS = "stats/admin/store-collections", // GET, POST
  STATS__ADMIN_STORE_COLLECTION = "stats/admin/store-collections/{collectionId}", // PATCH, DELETE
  STATS__ADMIN_ALL = "stats/admin/all/start-date/{startDate}/end-date/{endDate}", // GET
  STATS__ADMIN_ADDON_CARD = "stats/admin/addon-card/start-date/{startDate}/end-date/{endDate}", // GET
  TRENDS__ADMIN_ALL = "trends/admin/all/time-unit/{timeUnit}/end-date/{endDate}", // GET
  // Admin: what each store would pay with a per-job fee instead of a monthly price
  STATS__ADMIN_PLATFORM_FEE_SIMULATION = "stats/admin/platform-fee-simulation", // GET

  SERVICE_BIKE__FIND_BY_CUSTOMER = "service-bike/customer/store/{storeId}", // GET
  SERVICE_BIKE__GET_CONDITION = "service-bike/condition/job/{jobId}", // GET
  SERVICE_BIKE__UPDATE = "service-bike/job/{jobId}", // PATCH
  BIKE_BRAND__FIND_ALL = "service-bike/brands", // GET
  BIKE_BRAND__SAVE = "bike-brand", // POST
  ELECTRIC_SYSTEM__SAVE = "electric-system", // POST
  LEASING_COMPANY__SAVE = "leasing-company", // POST

  SUPPLIER__FIND_ALL = "supplier/all", // GET
  SUPPLIER__SEARCH = "supplier/search", // GET
  SUPPLIER__SAVE = "supplier", // POST

  DELIVERY_PRODUCT__SEARCH = "delivery-product/store/{storeId}/search", // GET
  DELIVERY_PRODUCT__SAVE = "delivery-product/store/{storeId}", // POST

  WORK_ORDER__FIND_ONE = "work-order/job/{jobId}", // GET
  WORK_ORDER__UPDATE_WASH_TASK = "work-order/wash-snapshot/{washSnapshotId}/job/{jobId}", // PATCH
  WORK_ORDER__UPDATE_PACKAGE_TASK = "work-order/package/{packageTaskId}/job/{jobId}", // PATCH
  WORK_ORDER__UPDATE_PART_TASK = "work-order/part/{partId}/job/{jobId}", // PATCH
  WORK_ORDER__UPDATE_MANUAL_SERVICE_ACTION_TASK = "work-order/manual-service-action/{manualServiceActionId}/job/{jobId}", // PATCH
  WORK_ORDER__UPDATE_FEE_SNAPSHOT = "work-order/fee-snapshot/{snapshotId}/job/{jobId}", // PATCH
  WORK_ORDER__BATCH_UPDATE_PRODUCT_PRICES = "work-order/product-prices/job/{jobId}", // PATCH
  WORK_ORDER__UPDATE_RECEIPT = "work-order/receipt/job/{jobId}", // PATCH
  WORK_ORDER__ADD_PRODUCT_TO_ACTION = "work-order/add-product/job/{jobId}", // POST
  WORK_ORDER__UPDATE_PRODUCT_ARTICLE_NUMBER = "work-order/update-product-article-number/job/{jobId}/product/{productId}", // PATCH
  WORK_ORDER__DELETE_PRODUCT_FROM_ACTION = "work-order/delete-product/job/{jobId}/product/{productId}", // DELETE
  WORK_ORDER__DELETE_WASH_TASK = "work-order/wash-snapshot/{washSnapshotId}/job/{jobId}", // DELETE
  WORK_ORDER__DELETE_PACKAGE_TASK = "work-order/package/{packageTaskId}/job/{jobId}", // DELETE
  WORK_ORDER__DELETE_PART_TASK = "work-order/part/{partId}/job/{jobId}", // DELETE
  WORK_ORDER__DELETE_MANUAL_SERVICE_ACTION_TASK = "work-order/manual-service-action/{manualServiceActionId}/job/{jobId}", // DELETE
  WORK_ORDER__DELETE_FEE_SNAPSHOT = "work-order/fee-snapshot/{snapshotId}/job/{jobId}", // DELETE
  WORK_ORDER__GET_ALL_IS_DONE = "work-order/is-done/job/{jobId}", // GET
  WORK_ORDER__BATCH_UPDATE_ALL_TASKS_IS_DONE = "work-order/batch-update-is-done/job/{jobId}", // PATCH
  WORK_ORDER__REPLACE_CONTENTS = "work-order/replace/job/{jobId}", // PUT
  WORK_TIME_RECORDING__FIND_BY_JOB = "work-time-recording/job/{jobId}", // GET
  WORK_TIME_RECORDING__UPDATE = "work-time-recording/job/{jobId}/recording/{recordingId}", // PATCH
  WORK_TIME_RECORDING__DELETE = "work-time-recording/job/{jobId}/recording/{recordingId}", // DELETE
  WORK_TIME_RECORDING__START = "work-time-recording/job/{jobId}/start", // POST
  WORK_TIME_RECORDING__STOP = "work-time-recording/job/{jobId}/stop", // POST
  WORK_TIME_RECORDING__STATS_BY_STORE = "work-time-recording/store/{storeId}/stats", // GET
  WORK_TIME_RECORDING__FIND_MANY_BY_PART_ACTION = "work-time-recording/store/{storeId}/part/{partId}/action/{action}", // GET

  ADDON_ORDER__GET_REQUIRED_DATA = "addon-order/job/{jobId}/required-data", // GET
  ADDON_ORDER__SEND_PROPOSAL = "addon-order/job/{jobId}/send-proposal", // POST
  ADDON_ORDER__GET_PROPOSAL = "addon-order/job/{jobId}/proposal", // GET
  ADDON_ORDER__ACCEPT = "addon-order/job/{jobId}/accept", // POST
  ADDON_ORDER__GET_ANSWERED = "addon-order/job/{jobId}/answered", // GET
  ADDON_ORDER__GET_HISTORY = "addon-order/job/{jobId}/history", // GET
  ADDON_ORDER__GET_DRAFT = "addon-order/job/{jobId}/draft", // GET
  ADDON_ORDER__SAVE_DRAFT = "addon-order/job/{jobId}/draft", // PUT
  ADDON_ORDER__DELETE_DRAFT = "addon-order/job/{jobId}/draft", // DELETE
  ADDON_ORDER__REVOKE = "addon-order/job/{jobId}/revoke", // POST

  RECEIPT__GET_AS_MECHANIC = "receipt/job/{jobId}", // GET
  RECEIPT__GET_AS_CUSTOMER = "receipt-as-customer/job/{jobId}", // GET
  RECEIPT__GET_COMBINED = "receipt/combined/store/{storeId}", // POST
  RECEIPT__CRON_BACKFILL_JOB_TOTALS = "receipt/cron/backfill-job-totals", // POST - Cron auth

  SERVICE_PROPOSAL__GET_PROPOSAL = "service-proposal/job/{jobId}", // GET
  SERVICE_PROPOSAL__GET_CONTEXT = "service-proposal/context/job/{jobId}", // GET - No auth
  SERVICE_PROPOSAL__GENERATE_PROPOSAL_PREVIEW = "service-proposal/preview", // POST
  SERVICE_PROPOSAL__GENERATE_INSPECTION_PREVIEW = "service-proposal/inspection-preview", // POST
  SERVICE_PROPOSAL__ACCEPT_PROPOSAL = "service-proposal/accept/job/{jobId}", // POST
  SERVICE_PROPOSAL__OPTIMIZE = "service-proposal/optimize/job/{jobId}", // POST
  SERVICE_PROPOSAL__LEVEL_PRESETS = "service-proposal/level-presets/job/{jobId}", // POST
  SERVICE_PROPOSAL__AB_TEST_EXPOSURE = "service-proposal/ab-test-exposure/job/{jobId}", // POST - No auth
  SERVICE_PROPOSAL__ADMIN_AB_TEST_RESULTS = "service-proposal/admin/ab-test-results", // GET
  SERVICE_PROPOSAL__ADMIN_AB_TEST_EXCLUDE_JOB = "service-proposal/admin/ab-test-results/job/{jobId}", // DELETE
  SERVICE_PROPOSAL__SELECTION = "service-proposal/selection/job/{jobId}", // POST - No auth

  SERVICE_JOB_PACKAGE_CONTROLLER__CREATE = "service-job/package/store/{storeId}", // POST
  SERVICE_JOB_PACKAGE_CONTROLLER__FIND_ONE_BY_ID = "service-job/package/{packageId}", // GET
  SERVICE_JOB_PACKAGE_CONTROLLER__FIND_MANY_BY_STORE_ID = "service-job/package/store/{storeId}", // GET
  SERVICE_JOB_PACKAGE_CONTROLLER__UPDATE = "service-job/package/{packageId}", // PATCH
  SERVICE_JOB_PACKAGE_CONTROLLER__DELETE = "service-job/package/{packageId}", // DELETE
  SERVICE_JOB_PACKAGE_CONTROLLER__DUPLICATE = "service-job/package/{packageId}/duplicate", // POST

  SERVICE_JOB_PACKAGE_CONTROLLER__ADD_ITEM = "service-job/package/{packageId}", // POST
  SERVICE_JOB_PACKAGE_CONTROLLER__UPDATE_ITEM_ACTION = "service-job/package/{packageId}/part/{partId}", // PATCH
  SERVICE_JOB_PACKAGE_CONTROLLER__DELETE_ITEM = "service-job/package/{packageId}/part/{partId}", // DELETE

  SERVICE_JOB_PACKAGE_CONTROLLER__SET_WASH = "service-job/package/{packageId}/wash", // PUT

  SERVICE_JOB_WASH_CONTROLLER__CREATE = "service-job/wash/{storeId}", // POST
  SERVICE_JOB_WASH_CONTROLLER__FIND_MANY_BY_STORE_ID = "service-job/wash/store/{storeId}", // GET
  SERVICE_JOB_WASH_CONTROLLER__FIND_ONE_BY_ID = "service-job/wash/{washId}", // GET
  SERVICE_JOB_WASH_CONTROLLER__UPDATE = "service-job/wash/{washId}", // PATCH
  SERVICE_JOB_WASH_CONTROLLER__DELETE = "service-job/wash/{washId}", // DELETE

  SERVICE_JOB_FEE_CONTROLLER__CREATE = "service-job/fee/{storeId}", // POST
  SERVICE_JOB_FEE_CONTROLLER__FIND_MANY_BY_STORE_ID = "service-job/fee/store/{storeId}", // GET
  SERVICE_JOB_FEE_CONTROLLER__UPDATE = "service-job/fee/{feeId}", // PATCH
  SERVICE_JOB_FEE_CONTROLLER__DELETE = "service-job/fee/{feeId}", // DELETE
  SERVICE_JOB_FEE_CONTROLLER__UPDATE_STANDARD = "service-job/fee/{feeId}/standard", // PATCH

  JOB_TABLE_VIEW__LIST = "job-table-view/store/{storeId}", // GET
  JOB_TABLE_VIEW__CREATE = "job-table-view/store/{storeId}", // POST
  JOB_TABLE_VIEW__REORDER = "job-table-view/store/{storeId}/order", // PUT
  JOB_TABLE_VIEW__FILTER_OPTIONS = "job-table-view/store/{storeId}/filter-options", // GET
  JOB_TABLE_VIEW__UPDATE = "job-table-view/store/{storeId}/view/{viewId}", // PATCH
  JOB_TABLE_VIEW__DELETE = "job-table-view/store/{storeId}/view/{viewId}", // DELETE
  JOB_TABLE_VIEW__DUPLICATE = "job-table-view/store/{storeId}/view/{viewId}/duplicate", // POST
  JOB_TABLE_VIEW__FIND_ROWS = "job-table-view/store/{storeId}/view/{viewId}/rows", // GET
  JOB_LABEL__FIND_ALL = "job-label/store/{storeId}", // GET
  JOB_LABEL__SAVE = "job-label/store/{storeId}", // POST
  JOB_LABEL__UPDATE = "job-label/{jobLabelId}", // PATCH
  JOB_LABEL__DELETE = "job-label/{jobLabelId}", // DELETE
  JOB_LABEL__SET_LINKS_FOR_JOB = "job-label/job/{jobId}", // PUT

  DISCOUNT_CODE_CONTROLLER__CREATE = "discount-code/store/{storeId}", // POST
  DISCOUNT_CODE_CONTROLLER__FIND_MANY_BY_STORE_ID = "discount-code/store/{storeId}", // GET
  DISCOUNT_CODE_CONTROLLER__UPDATE = "discount-code/{codeId}", // PATCH
  DISCOUNT_CODE_CONTROLLER__DELETE = "discount-code/{codeId}", // DELETE
  DISCOUNT_CODE_CONTROLLER__VALIDATE = "discount-code/validate/store/{storeId}", // POST
  DISCOUNT_CODE_CONTROLLER__STATS = "discount-code/stats/store/{storeId}", // GET
  DISCOUNT_CODE_CONTROLLER__EXCLUDABLE_PART_ACTIONS = "discount-code/excludable-part-actions/store/{storeId}", // GET
  DISCOUNT_CODE_CONTROLLER__APPLY_TO_JOB = "discount-code/{codeId}/job/{jobId}", // POST
  DISCOUNT_CODE_CONTROLLER__REMOVE_FROM_JOB = "discount-code/job/{jobId}", // DELETE

  CUSTOM_BOOKING_SECTION_CONTROLLER__CREATE = "custom-booking-section/store/{storeId}", // POST
  CUSTOM_BOOKING_SECTION_CONTROLLER__FIND_MANY_BY_STORE_ID = "custom-booking-section/store/{storeId}", // GET
  CUSTOM_BOOKING_SECTION_CONTROLLER__FIND_ONE_BY_ID = "custom-booking-section/section/{sectionId}", // GET
  CUSTOM_BOOKING_SECTION_CONTROLLER__UPDATE = "custom-booking-section/section/{sectionId}", // PATCH
  CUSTOM_BOOKING_SECTION_CONTROLLER__DELETE = "custom-booking-section/section/{sectionId}", // DELETE
  CUSTOM_BOOKING_SECTION_CONTROLLER__CREATE_ITEM = "custom-booking-section/section/{sectionId}/item", // POST
  CUSTOM_BOOKING_SECTION_CONTROLLER__UPDATE_ITEM = "custom-booking-section/item/{itemId}", // PATCH
  CUSTOM_BOOKING_SECTION_CONTROLLER__DELETE_ITEM = "custom-booking-section/item/{itemId}", // DELETE

  BOOKING_STEP_ORDER_CONTROLLER__CREATE = "booking-step-order/store/{storeId}", // POST
  BOOKING_STEP_ORDER_CONTROLLER__FIND_MANY_BY_STORE_ID = "booking-step-order/store/{storeId}", // GET
  BOOKING_STEP_ORDER_CONTROLLER__FIND_ONE_BY_ID = "booking-step-order/{id}", // GET
  BOOKING_STEP_ORDER_CONTROLLER__UPDATE = "booking-step-order/{id}", // PATCH
  BOOKING_STEP_ORDER_CONTROLLER__DELETE = "booking-step-order/{id}", // DELETE
  BOOKING_STEP_ORDER_CONTROLLER__UPSERT_MANY = "booking-step-order/store/{storeId}/bulk", // PUT

  PROPER_INSPECTION_CONTROLLER__CREATE = "proper-inspection/store/{storeId}/job/{jobId}", // POST
  PROPER_INSPECTION_CONTROLLER__SAVE_DRAFT = "proper-inspection/draft/store/{storeId}/job/{jobId}", // POST
  PROPER_INSPECTION_CONTROLLER__REVOKE_PROPOSAL = "proper-inspection/revoke-proposal/store/{storeId}/job/{jobId}", // POST
  PROPER_INSPECTION_CONTROLLER__RESET_TO_SENT_INSPECTION = "proper-inspection/reset-to-sent/store/{storeId}/job/{jobId}", // POST
  PROPER_INSPECTION_CONTROLLER__SEND_PROPOSAL_EMAIL = "proper-inspection/send-proposal-email/store/{storeId}/job/{jobId}", // POST
  PROPER_INSPECTION_CONTROLLER__FIND_PROPER_INSPECTION_DATA_FOR_JOB = "proper-inspection/data/job/{jobId}", // GET
  PROPER_INSPECTION_CONTROLLER__FIND_PART_COMMENT_HISTORY = "proper-inspection/part-comment-history/store/{storeId}/part/{partId}", // GET

  MECHANIC_CONTROLLER__FIND_MANY_BY_STORE_ID = "mechanic/store-id/{storeId}", // GET
  MECHANIC_CONTROLLER__FIND_ONE_BY_ID = "mechanic/store-id/{storeId}/{mechanicId}", // GET
  MECHANIC_CONTROLLER__FIND_CURRENT = "mechanic/current/{storeId}", // GET

  RECEPTION_CONTROLLER__FIND_RECEPTION_DATA_FOR_STORE = "reception/data/{storeId}", // GET
  RECEPTION_CONTROLLER__FIND_RECEPTION_DATA_FOR_STORE_WITH_BOOKING = "reception/data/{storeId}/{jobId}", // GET
  RECEPTION_CONTROLLER__FIND_ONE_BY_JOB_ID = "reception/job/{jobId}", // GET

  NEW_MANUAL_RECEPTION_CONTROLLER__CREATE = "new-manual-reception/store/{storeId}", // POST
  NEW_MANUAL_RECEPTION_CONTROLLER__QUICK_RECEPTION = "new-manual-reception/store/{storeId}/quick", // POST

  PRICE_LIST__CREATE = "price-list/store/{storeId}", // POST
  PRICE_LIST__FIND_MANY = "price-list/store/{storeId}", // GET
  PRICE_LIST__UPDATE = "price-list/{priceListId}", // PATCH
  PRICE_LIST__DELETE = "price-list/{priceListId}", // DELETE
  PRICE_LIST__DUPLICATE = "price-list/{priceListId}/duplicate", // POST
  PRICE_LIST__SET_DEFAULT = "price-list/{priceListId}/set-default", // POST

  COMPANY__CREATE = "company/store/{storeId}", // POST
  COMPANY__FIND_MANY = "company/store/{storeId}", // GET
  COMPANY__FIND_ONE = "company/{companyId}", // GET
  COMPANY__UPDATE = "company/{companyId}", // PATCH
  COMPANY__DELETE = "company/{companyId}", // DELETE
  DEPARTMENT__CREATE = "company/{companyId}/department", // POST
  DEPARTMENT__UPDATE = "department/{departmentId}", // PATCH
  DEPARTMENT__DELETE = "department/{departmentId}", // DELETE
  DEPARTMENT__MOVE = "department/{departmentId}/move", // PATCH
  COMPANY_CONTACT_PERSON__CREATE = "company/{companyId}/contact-person", // POST
  COMPANY_CONTACT_PERSON__UPDATE = "company-contact-person/{contactPersonId}", // PATCH
  COMPANY_CONTACT_PERSON__DELETE = "company-contact-person/{contactPersonId}", // DELETE

  INVOICE__CREATE = "invoice/store/{storeId}", // POST
  INVOICE__CREATE_FROM_JOB = "invoice/job/{jobId}", // POST
  INVOICE__FIND_MANY_BY_COMPANY = "invoice/company/{companyId}", // GET
  INVOICE__FIND_ONE_BY_NUMBER = "invoice/company/{companyId}/number/{displayNumber}", // GET
  INVOICE__FIND_ONE = "invoice/{invoiceId}", // GET
  INVOICE__UPDATE_ROWS = "invoice/{invoiceId}/rows", // PATCH
  INVOICE__UPDATE_JOBS = "invoice/{invoiceId}/jobs", // PATCH
  INVOICE__UPDATE_REFERENCES = "invoice/{invoiceId}/references", // PATCH
  INVOICE__SET_INVOICED = "invoice/{invoiceId}/invoiced", // PATCH
  INVOICE__DELETE = "invoice/{invoiceId}", // DELETE
  INVOICE__DOWNLOAD_PDF = "invoice/{invoiceId}/pdf", // GET
  INVOICE__SEND_TO_SPECTER = "invoice/{invoiceId}/send-to-specter", // POST

  PART_EVALUATION_CONTROLLER__FIND_ALL = "part-evaluation", // GET
  PART_EVALUATION_CONTROLLER__CREATE = "part-evaluation", // POST
  PART_EVALUATION_CONTROLLER__UPDATE = "part-evaluation/{partId}", // PATCH
  PART_EVALUATION_CONTROLLER__DELETE = "part-evaluation/{partId}", // DELETE
  PART_EVALUATION_CONTROLLER__FIND_ONE_WITH_STORE_SETTINGS = "part-evaluation/store-id/{storeId}/{partId}", // GET
  PART_EVALUATION_CONTROLLER__FIND_MANY_WITH_STORE_SETTINGS = "part-evaluation/store-id/{storeId}", // GET
  PART_EVALUATION_CONTROLLER__APPLY_STORE_SETTINGS = "part-evaluation/apply-store-settings/{storeId}", // PATCH
  PART_EVALUATION_CONTROLLER__FIND_INSPECTION_ORDERS = "part-evaluation/inspection-orders/{storeId}", // GET
  PART_EVALUATION_CONTROLLER__CREATE_INSPECTION_ORDER = "part-evaluation/inspection-orders/{storeId}", // POST
  PART_EVALUATION_CONTROLLER__UPDATE_INSPECTION_ORDER = "part-evaluation/inspection-orders/{storeId}/{inspectionOrderId}", // PATCH
  PART_EVALUATION_CONTROLLER__DELETE_INSPECTION_ORDER = "part-evaluation/inspection-orders/{storeId}/{inspectionOrderId}", // DELETE
  PART_EVALUATION_CONTROLLER__BULK_UPDATE_STORE_SETTINGS = "part-evaluation/bulk-store-settings/{storeId}", // PATCH
  PART_EVALUATION_CONTROLLER__AUTO_CALCULATE_PRICES = "part-evaluation/auto-calculate-prices/{storeId}", // POST
  PART_EVALUATION_CONTROLLER__DEACTIVATE_PART = "part-evaluation/deactivate/{storeId}/{partId}", // POST
  PART_EVALUATION_CONTROLLER__ACTIVATE_PART = "part-evaluation/activate/{storeId}/{partId}", // DELETE
  PART_EVALUATION_CONTROLLER__GET_DEACTIVATED_PARTS = "part-evaluation/deactivated/{storeId}", // GET
  PART_EVALUATION_CONTROLLER__UPDATE_AVAILABLE_ACTIONS = "part-evaluation/available-actions/{partId}", // PATCH
  PART_EVALUATION_CONTROLLER__UPDATE_DEFAULT_DURATION = "part-evaluation/default-duration/{partId}", // PATCH

  BOOKING__BOOK_MAINTENANCE_AS_CUSTOMER = "booking/maintenance-as-customer", // POST
  BOOKING__BOOK_MAINTENANCE_AS_MECHANIC = "booking/maintenance-as-mechanic", // POST
  BOOKING__BOOK_EMERGENCY_AS_CUSTOMER = "booking/emergency-as-customer", // POST
  BOOKING__BOOK_EMERGENCY_AS_MECHANIC = "booking/emergency-as-mechanic", // POST
  BOOKING__FIND_MAINTENANCE_AVAILABILITY = "booking/maintenance-availability/store/{storeId}", // GET
  BOOKING__FIND_MAINTENANCE_DAY_STATUSES = "booking/maintenance-day-statuses/store/{storeId}", // GET
  BOOKING__FIND_REQUIRED_MAINTENANCE_DATA = "booking/required-maintenance-data/store/{storeId}", // GET
  BOOKING__FIND_REQUIRED_EMERGENCY_DATA = "booking/required-emergency-data/store/{storeId}", // GET
  BOOKING__FIND_ONE = "booking/job/{jobId}", // GET
  BOOKING__RESCHEDULE = "bike-service/booking/reschedule/job/{jobId}", // PATCH
  BOOKING__FIND_RESCHEDULE_AVAILABILITY = "bike-service/booking/reschedule/job/{jobId}/availability", // GET
  BOOKING__CANCEL = "bike-service/booking/cancel/job/{jobId}", // PATCH
  BOOKING__FIND_CANCELLATION_OPTIONS = "bike-service/booking/cancel/job/{jobId}/options", // GET
  BOOKING__UPLOAD_IMAGES = "booking/{jobId}/images", // POST
  BOOKING__UPLOAD_DAMPER_IMAGES = "booking/{jobId}/damper-images", // POST

  JOB_CONTROLLER__FIND_MANY_BY_STORE_ID = "bike-service/job/store-id/{storeId}", // GET
  JOB_CONTROLLER__FIND_ONE_EXTENDED_AS_STORE = "bike-service/job/{jobId}/details/as-store", // GET
  JOB_CONTROLLER__FIND_ONE_EXTENDED_AS_CUSTOMER = "bike-service/job/{jobId}/details/as-customer", // GET
  JOB_CONTROLLER__FIND_CONNECTED_JOBS_AS_CUSTOMER = "bike-service/job/{jobId}/connected-jobs/as-customer", // GET
  JOB_CONTROLLER__FIND_STORE_ACCESS = "bike-service/job/{jobId}/store-access", // GET
  JOB_CONTROLLER__SET_JOB_STATUS = "bike-service/job/{jobId}/status", // PATCH
  JOB_CONTROLLER__SET_PICKUP_REMINDER_PAUSE = "bike-service/job/{jobId}/pickup-reminder-pause", // PATCH
  JOB_CONTROLLER__GET_PICKUP_REMINDERS = "bike-service/job/{jobId}/pickup-reminders", // GET
  JOB_CONTROLLER__GET_IS_DONE_MESSAGE = "bike-service/job/{jobId}/is-done-message", // GET
  JOB_CONTROLLER__GET_WAITING_FOR_PARTS_MESSAGE = "bike-service/job/{jobId}/waiting-for-parts-message", // GET
  JOB_CONTROLLER__GET_RECEPTION_CONFIRMATION_MESSAGE = "bike-service/job/{jobId}/reception-confirmation-message", // GET
  JOB_CONTROLLER__GET_PRICE_PROPOSAL_REMINDER_MESSAGE = "bike-service/job/{jobId}/price-proposal-reminder-message", // GET
  JOB_CONTROLLER__GET_BIKE_DONE_REMINDER_MESSAGE = "bike-service/job/{jobId}/bike-done-reminder-message", // GET
  JOB_CONTROLLER__GET_STORE_PRICE_PROPOSAL_REMINDER_MESSAGE = "bike-service/store/{storeId}/price-proposal-reminder-message", // GET
  JOB_CONTROLLER__GET_STORE_BIKE_DONE_REMINDER_MESSAGE = "bike-service/store/{storeId}/bike-done-reminder-message", // GET
  JOB_CONTROLLER__GET_ADDON_ORDER_REMINDER_MESSAGE = "bike-service/job/{jobId}/addon-order-reminder-message", // GET
  JOB_CONTROLLER__GET_STORE_ADDON_ORDER_REMINDER_MESSAGE = "bike-service/store/{storeId}/addon-order-reminder-message", // GET
  JOB_CONTROLLER__UPDATE_JOB_POSITION = "bike-service/store/{storeId}/position", // PATCH
  JOB_CONTROLLER__FIND_MANY_BETWEEN_DATES = "bike-service/job/between-dates/store-id/{storeId}", // GET
  JOB_CONTROLLER__FIND_SUMMARIES_BY_STATUS = "bike-service/job/summaries/store-id/{storeId}", // GET
  JOB_CONTROLLER__FIND_WAITING_FOR_RESPONSE = "bike-service/job/waiting-for-response/store-id/{storeId}", // GET
  JOB_CONTROLLER__FIND_READY_FOR_SERVICE = "bike-service/job/ready-for-service/store-id/{storeId}", // GET
  JOB_CONTROLLER__FIND_WAITING_FOR_DELIVERY = "bike-service/job/waiting-for-delivery/store-id/{storeId}", // GET
  JOB_CONTROLLER__SET_IS_WAITING_FOR_PART_STATUS = "bike-service/job/{jobId}/is-waiting-for-part", // PATCH
  JOB_CONTROLLER__SET_WAITING_FOR_PARTS_WITH_DATE = "bike-service/job/{jobId}/waiting-for-parts-with-date", // PATCH
  JOB_CONTROLLER__CLEAR_WAITING_FOR_PARTS = "bike-service/job/{jobId}/clear-waiting-for-parts", // PATCH
  JOB_CONTROLLER__SET_IS_TEMPORARILY_HANDED_OUT = "bike-service/job/{jobId}/is-temporarily-handed-out", // PATCH
  JOB_CONTROLLER__SET_SEND_REVIEW_REQUEST = "bike-service/job/{jobId}/send-review-request", // PATCH
  JOB_CONTROLLER__SET_INVOICED = "bike-service/job/{jobId}/invoiced", // PATCH
  JOB_CONTROLLER__GET_PART_DELIVERED_MESSAGE = "bike-service/job/{jobId}/part-delivered-message", // GET
  JOB_CONTROLLER__UPDATE_PHYSICAL_TAG = "bike-service/job/{jobId}/physical-tag", // PATCH
  JOB_CONTROLLER__UPDATE_LEASING_ID = "bike-service/job/{jobId}/leasing-id", // PATCH
  JOB_CONTROLLER__UPDATE_SIZE = "bike-service/job/{jobId}/size", // PATCH
  JOB_CONTROLLER__UPDATE_ASSIGNED_MECHANIC = "bike-service/job/{jobId}/assigned-mechanic", // PATCH
  JOB_CONTROLLER__UPDATE_RECEPTION_MECHANIC = "bike-service/job/{jobId}/reception-mechanic", // PATCH
  JOB_CONTROLLER__UPDATE_INSPECTION_MECHANIC = "bike-service/job/{jobId}/inspection-mechanic", // PATCH
  JOB_CONTROLLER__GET_AVAILABLE_PHYSICAL_TAGS = "bike-service/store/{storeId}/available-physical-tags", // GET
  JOB_CONTROLLER__FIND_BY_CUSTOMER = "bike-service/job/customer/store/{storeId}", // GET
  JOB_CONTROLLER__SEARCH = "bike-service/job/search/store/{storeId}", // GET
  JOB_CONTROLLER__BULK_UPDATE_STATUS = "bike-service/job/bulk/status/store/{storeId}", // PATCH
  JOB_CONTROLLER__BULK_UPDATE_ASSIGNED_MECHANIC = "bike-service/job/bulk/assigned-mechanic/store/{storeId}", // PATCH
  JOB_CONTROLLER__BULK_UPDATE_HAND_IN_DATE = "bike-service/job/bulk/hand-in-date/store/{storeId}", // PATCH
  JOB_CONTROLLER__BULK_MARK_INVOICED = "bike-service/job/bulk/invoiced/store/{storeId}", // PATCH
  JOB_CONTROLLER__FIND_MANY_BY_COMPANY = "bike-service/job/by-company/store/{storeId}", // GET
  JOB_CONTROLLER__COMPANY_JOB_FILTER_OPTIONS = "bike-service/job/company-filter-options/store/{storeId}", // GET
  JOB_CONTROLLER__COMPANY_JOB_COUNTS = "bike-service/job/by-company/counts/store/{storeId}", // GET
  JOB_CONTROLLER__FIND_MANY_BY_IDS = "bike-service/job/by-ids/store/{storeId}", // GET
  CONNECTED_JOBS_GROUP__FIND_JOBS = "connected-jobs-group/{groupId}/jobs/store/{storeId}", // GET
  JOB_CONTROLLER__UPDATE_HAND_IN_DATE = "bike-service/job/{jobId}/hand-in-date", // PATCH
  JOB_CONTROLLER__UPDATE_PRICE_LIST = "bike-service/job/{jobId}/price-list", // PATCH
  JOB_CONTROLLER__UPDATE_REFERENCE = "bike-service/job/{jobId}/reference", // PATCH
  JOB_CONTROLLER__UPDATE_COMPANY_CONTACT_PERSON = "bike-service/job/{jobId}/company-contact-person", // PATCH
  JOB_CONTROLLER__UPLOAD_ATTACHMENTS = "bike-service/job/{jobId}/attachments", // POST
  JOB_CONTROLLER__DELETE_ATTACHMENT = "bike-service/job/{jobId}/attachments/{attachmentId}", // DELETE
  ATTACHMENT_STAGING__UPLOAD = "attachment-staging/store/{storeId}/upload", // POST

  MESSAGE_CONTROLLER__FIND_MANY_CHATS_BY_STORE_ID = "bike-service/message/chats/{storeId}", // GET
  MESSAGE_CONTROLLER__FIND_NUM_UNREAD_MESSAGES = "bike-service/message/num-unread/{storeId}", // GET
  MESSAGE_CONTROLLER__SEND_AS_CUSTOMER = "bike-service/message/as-customer", // POST
  MESSAGE_CONTROLLER__SET_MESSAGE_IS_READ_STATUS = "bike-service/message/set-message-is-read-status", // PATCH
  MESSAGE_CONTROLLER__MARK_CHATS_AS_READ = "bike-service/message/mark-chats-as-read", // PATCH
  MESSAGE_CONTROLLER__SEND_SMS_AS_STORE_STAFF = "bike-service/message/sms/{jobId}", // POST
  MESSAGE_CONTROLLER__SEND_EMAIL_AS_STORE_STAFF = "bike-service/message/email/{jobId}", // POST
  MESSAGE_CONTROLLER__SCHEDULE_AS_STORE_STAFF = "bike-service/message/scheduled/{jobId}", // POST
  MESSAGE_CONTROLLER__CANCEL_SCHEDULED = "bike-service/message/scheduled/{jobId}/{groupId}", // DELETE
  MESSAGE_CONTROLLER__DISPATCH_SCHEDULED = "bike-service/message/scheduled/{jobId}/{groupId}/dispatch", // POST - Cron auth (Cloud Tasks)
  MESSAGE_CONTROLLER__SEND_SCHEDULED_NOW = "bike-service/message/scheduled/{jobId}/{groupId}/send-now", // POST
  MESSAGE_CONTROLLER__SMS_PREVIEW = "bike-service/message/sms-preview/{jobId}", // GET
  MESSAGE_CONTROLLER__SMS_BREAKDOWN = "bike-service/message/sms-breakdown/{jobId}/{messageId}", // GET
  MESSAGE_CONTROLLER__FIND_MANY_BY_STORE_CUSTOMER = "bike-service/message/store-customer/{storeCustomerId}", // GET
  MESSAGE_CONTROLLER__FIND_MANY_BY_STORE_CUSTOMER_AS_CUSTOMER = "bike-service/message/store-customer/{storeCustomerId}/as-customer", // GET - no auth
  MESSAGE_CONTROLLER__SEND_AS_STORE_CUSTOMER = "bike-service/message/as-store-customer", // POST - no auth
  MESSAGE_CONTROLLER__SET_STORE_CUSTOMER_MESSAGE_IS_READ_STATUS = "bike-service/message/store-customer/{storeCustomerId}/messages/{messageId}/read-status", // PATCH
  MESSAGE_CONTROLLER__SMS_PREVIEW_FOR_STORE_CUSTOMER = "bike-service/message/store-customer/{storeCustomerId}/sms-preview", // GET
  MESSAGE_CONTROLLER__SMS_BREAKDOWN_FOR_STORE_CUSTOMER = "bike-service/message/store-customer/{storeCustomerId}/messages/{messageId}/sms-breakdown", // GET
  MESSAGE_CONTROLLER__SCHEDULE_TO_STORE_CUSTOMER = "bike-service/message/store-customer/{storeCustomerId}/scheduled", // POST
  MESSAGE_CONTROLLER__CANCEL_SCHEDULED_TO_STORE_CUSTOMER = "bike-service/message/store-customer/{storeCustomerId}/scheduled/{groupId}", // DELETE
  MESSAGE_CONTROLLER__DISPATCH_SCHEDULED_TO_STORE_CUSTOMER = "bike-service/message/store-customer/{storeCustomerId}/scheduled/{groupId}/dispatch", // POST - Cron auth (Cloud Tasks)
  MESSAGE_CONTROLLER__SEND_SCHEDULED_NOW_TO_STORE_CUSTOMER = "bike-service/message/store-customer/{storeCustomerId}/scheduled/{groupId}/send-now", // POST

  // Support Chat (Store)
  SUPPORT_CHAT__FIND_MESSAGES = "support-chat/store/{storeId}/messages", // GET
  SUPPORT_CHAT__SEND_AS_STORE = "support-chat/store/{storeId}/messages", // POST
  SUPPORT_CHAT__MARK_READ_AS_STORE = "support-chat/store/{storeId}/mark-read", // PATCH
  SUPPORT_CHAT__UNREAD_COUNT_FOR_STORE = "support-chat/store/{storeId}/unread-count", // GET
  SUPPORT_CHAT__SET_MESSAGE_READ_STATUS_AS_STORE = "support-chat/store/{storeId}/message-read-status", // PATCH

  // Support Chat (Admin)
  SUPPORT_CHAT__ADMIN_FIND_THREADS = "support-chat/admin/threads", // GET
  SUPPORT_CHAT__ADMIN_FIND_MESSAGES = "support-chat/admin/thread/{threadId}/messages", // GET
  SUPPORT_CHAT__ADMIN_SEND_MESSAGE = "support-chat/admin/thread/{threadId}/messages", // POST
  SUPPORT_CHAT__ADMIN_MARK_READ = "support-chat/admin/thread/{threadId}/mark-read", // PATCH
  SUPPORT_CHAT__ADMIN_UNREAD_COUNT = "support-chat/admin/unread-count", // GET
  SUPPORT_CHAT__ADMIN_SET_MESSAGE_READ_STATUS = "support-chat/admin/thread/{threadId}/message-read-status", // PATCH
  SUPPORT_CHAT__ADMIN_CREATE_THREAD = "support-chat/admin/thread/store/{storeId}", // POST

  // Julo Updates (release notes feed for mechanics).
  // Entries themselves live in the CRM code; the API only stores per-user read
  // status keyed by the entry slug.
  JULO_UPDATE__READ_STATUSES = "julo-update/store/{storeId}/read-statuses", // GET
  JULO_UPDATE__SET_READ_STATUS = "julo-update/store/{storeId}/read-status/{slug}", // PATCH
  JULO_UPDATE__MARK_ALL_READ = "julo-update/store/{storeId}/mark-all-read", // PATCH

  // Onboarding videos (the per-user watched state for the Onboarding page).
  // The video catalogue itself lives in the CRM code; the API only stores
  // which slugs the current user has marked as watched.
  ONBOARDING__WATCHED_STATUSES = "onboarding/store/{storeId}/watched-statuses", // GET
  ONBOARDING__SET_WATCHED = "onboarding/store/{storeId}/watched/{slug}", // PATCH

  SERVICE_SETTINGS_CONTROLLER__CREATE = "bike-service/settings/{storeId}", // POST
  SERVICE_SETTINGS_CONTROLLER__FIND_ONE_BY_STORE_ID = "bike-service/settings/{storeId}", // GET
  SERVICE_SETTINGS_CONTROLLER__FIND_ONE_BY_STORE_SLUG = "bike-service/settings/store-slug/{storeSlug}", // GET
  SERVICE_SETTINGS_CONTROLLER__UPDATE = "bike-service/settings/update/{storeId}", // PATCH
  SERVICE_SETTINGS_CONTROLLER__FIND_DEFAULT_MESSAGES = "bike-service/default-messages", // GET
  SERVICE_SETTINGS_CONTROLLER__UPDATE_DEFAULT_MESSAGES = "bike-service/default-messages", // PUT (admin)

  DEFAULT_MATERIAL_PRICE_CONTROLLER__FIND_ALL_BY_STORE_ID = "default-material-price/store/{storeId}", // GET
  DEFAULT_MATERIAL_PRICE_CONTROLLER__UPDATE_PRICES = "default-material-price/store/{storeId}", // PUT

  JOB_CUSTOMER__FIND_ONE_BY_JOB_ID = "store-customer/job/{jobId}", // GET
  JOB_CUSTOMER__UPDATE = "store-customer/job/{jobId}", // PATCH
  JOB_CUSTOMER__SEARCH_CONTACT_DETAILS = "store-customer/store/{storeId}/contact-details/search", // GET
  JOB_CUSTOMER__FIND_CLUB_MEMBERSHIP = "store-customer/store/{storeId}/club-membership", // GET

  CUSTOMER_CLUB__FIND_ONE = "customer-club/store/{storeId}", // GET
  CUSTOMER_CLUB__UPDATE = "customer-club/store/{storeId}", // PATCH
  CUSTOMER_CLUB__FIND_MEMBERS = "customer-club/store/{storeId}/members", // GET
  CUSTOMER_CLUB__IMPORT_MEMBERS = "customer-club/store/{storeId}/members/import", // POST - multipart CSV file

  STORE_CUSTOMER__FIND_MANY = "customer/store/{storeId}", // GET
  STORE_CUSTOMER__CREATE = "customer/store/{storeId}", // POST
  STORE_CUSTOMER__SEARCH = "customer/store/{storeId}/search", // GET
  STORE_CUSTOMER__FIND_ONE = "customer/{storeCustomerId}", // GET
  STORE_CUSTOMER__UPDATE = "customer/{storeCustomerId}", // PATCH
  STORE_CUSTOMER__FIND_ONE_AS_CUSTOMER = "customer/{storeCustomerId}/as-customer", // GET - no auth, the id is the customer's link
  STORE_BIKE__FIND_MANY_BY_CUSTOMER = "store-bike/customer/{storeCustomerId}", // GET
  STORE_BIKE__CREATE = "store-bike/customer/{storeCustomerId}", // POST
  STORE_BIKE__FIND_ONE = "store-bike/customer/{storeCustomerId}/bike/{storeBikeId}", // GET
  STORE_BIKE__MERGE = "store-bike/customer/{storeCustomerId}/merge", // POST
  TIRE_STORAGE__FIND_MANY = "tire-storage/store/{storeId}", // GET
  TIRE_STORAGE__CREATE = "tire-storage/store/{storeId}", // POST
  TIRE_STORAGE__SEARCH = "tire-storage/store/{storeId}/search", // GET
  TIRE_STORAGE__EXPIRING_COUNT = "tire-storage/store/{storeId}/expiring-count", // GET
  TIRE_STORAGE__DEFAULTS = "tire-storage/store/{storeId}/defaults", // GET
  TIRE_STORAGE__GET_SETTINGS = "tire-storage/store/{storeId}/settings", // GET
  TIRE_STORAGE__UPDATE_SETTINGS = "tire-storage/store/{storeId}/settings", // PUT
  TIRE_STORAGE__REMINDER_PREVIEW = "tire-storage/store/{storeId}/reminder/preview", // GET
  TIRE_STORAGE__SEND_REMINDER = "tire-storage/store/{storeId}/reminder", // POST
  TIRE_STORAGE__FIND_ONE = "tire-storage/store/{storeId}/{tireStorageId}", // GET
  TIRE_STORAGE__UPDATE = "tire-storage/store/{storeId}/{tireStorageId}", // PATCH
  TIRE_STORAGE__MARK_RETURNED = "tire-storage/store/{storeId}/{tireStorageId}/returned", // POST
  TIRE_STORAGE__DISCARD = "tire-storage/store/{storeId}/{tireStorageId}/discard", // POST

  STORE_EMPLOYEE_CONTROLLER__FIND_ROLES_FOR_USER_AT_STORE = "store-employee/roles/{storeId}/{userId}", // GET
  STORE_EMPLOYEE_CONTROLLER__FIND_MANY_EMPLOYEES_BY_STORE_ID = "store-employee/employees/{storeId}", // GET
  STORE_EMPLOYEE_CONTROLLER__FIND_MANY_OWNERS_BY_STORE_ID = "store-employee/owners/{storeId}", // GET

  STORE_ACCOUNT_CONTROLLER__FIND_OVERVIEW = "store-account/{storeId}", // GET
  STORE_ACCOUNT_CONTROLLER__CREATE = "store-account/{storeId}", // POST
  STORE_ACCOUNT_CONTROLLER__LINK = "store-account/{storeId}/link", // POST
  STORE_ACCOUNT_CONTROLLER__CHANGE_LINK = "store-account/{storeId}/{mechanicId}/link", // PATCH
  STORE_ACCOUNT_CONTROLLER__UPDATE = "store-account/{storeId}/{mechanicId}", // PATCH
  STORE_ACCOUNT_CONTROLLER__INACTIVATE = "store-account/{storeId}/{mechanicId}/inactivate", // POST
  STORE_ACCOUNT_CONTROLLER__REACTIVATE = "store-account/{storeId}/{mechanicId}/reactivate", // POST
  STORE_ACCOUNT_CONTROLLER__DELETE_UNLINKED_MECHANIC = "store-account/{storeId}/unlinked-mechanic/{mechanicId}", // DELETE
  STORE_ACCOUNT_CONTROLLER__DELETE_UNLINKED_ACCOUNT = "store-account/{storeId}/unlinked-account/{userId}", // DELETE

  GDPR_CONTROLLER__ANONYMIZE_IRRELEVANT_CUSTOMERS = "gdpr", // POST

  LEGAL_DOCUMENT_CONTROLLER__CREATE = "legal-document", // POST

  PUBLIC_STORE_EMPLOYEE_CONTROLLER__CREATE = "public-store-employees/store/{storeId}", // POST
  PUBLIC_STORE_EMPLOYEE_CONTROLLER__FIND_MANY_BY_STORE_ID = "public-store-employees/{storeId}", // GET
  PUBLIC_STORE_EMPLOYEE_CONTROLLER__UPDATE = "public-store-employees/{publicStoreEmployeeId}", // PATCH
  PUBLIC_STORE_EMPLOYEE_CONTROLLER__DELETE = "public-store-employees/{publicStoreEmployeeId}", // DELETE

  STANDARD_OFFERING_CONTROLLER__CREATE = "standard-offering/store/{storeId}", // POST
  STANDARD_OFFERING_CONTROLLER__FIND_MANY_BY_STORE_ID = "standard-offering/{storeId}", // POST
  STANDARD_OFFERING_CONTROLLER__DELETE = "standard-offering/{standardOfferingId}", // DELETE

  CUSTOM_STORE_INFO_CONTROLLER__CREATE = "custom-store-info/store/{storeId}", // POST
  CUSTOM_STORE_INFO_CONTROLLER__FIND_MANY_BY_STORE_ID = "custom-store-info/store/{storeId}", // GET
  CUSTOM_STORE_INFO_CONTROLLER__DELETE = "custom-store-info/{customStoreInfoId}", // DELETE

  STORE__SEARCH = "store-search", // GET
  STORE__SEARCH_BY_NAME = "store-search-by-name", // GET
  STORE__MAP_PINS = "store-map-pins", // GET
  STORE__CARD = "store-card/{storeId}", // GET
  STORE_CONTROLLER__CREATE = "store", // POST
  STORE_CONTROLLER__FIND_ALL = "store", // GET
  STORE_CONTROLLER__FIND_ONE = "store/{storeId}", // GET
  STORE_CONTROLLER__FIND_ONE_BY_SLUG = "store/slug/{storeSlug}", // GET
  STORE_CONTROLLER__UPDATE = "store/{storeId}", // PATCH
  STORE_CONTROLLER__DELETE = "store/{storeId}", // DELETE
  STORE__ADMIN_FIND_ALL = "store/admin/all", // GET
  STORE__ADMIN_UPDATE_TIER = "store/admin/{storeId}/tier", // PATCH
  STORE__ADMIN_UPDATE = "store/admin/{storeId}", // PATCH
  STORE__ADMIN_FETCH_GOOGLE_PLACE_DETAILS = "store/admin/google-place-details/{googlePlaceId}", // GET
  STORE__REFRESH_OPENING_HOURS = "store/refresh-opening-hours", // POST
  STORE__REFRESH_STORE_OPENING_HOURS = "store/{storeId}/refresh-opening-hours", // POST
  STORE__LOGO = "store/{storeId}/logo", // GET
  STORE__SUGGEST_CHANGE = "store/{storeId}/suggest-change", // POST
  STORE__STRIPE_CONNECT_STATUS = "store/{storeId}/stripe-connect", // GET
  STORE__STRIPE_CONNECT_START_ONBOARDING = "store/{storeId}/stripe-connect/onboarding-link", // POST
  STORE__STRIPE_CONNECT_LINKABLE_ACCOUNTS = "store/{storeId}/stripe-connect/linkable-accounts", // GET
  STORE__STRIPE_CONNECT_LINK_EXISTING = "store/{storeId}/stripe-connect/link-existing", // POST
  STORE__STRIPE_CONNECT_DISCONNECT = "store/{storeId}/stripe-connect", // DELETE
  STORE__FORTNOX_STATUS = "store/{storeId}/fortnox", // GET
  STORE__FORTNOX_CONNECT = "store/{storeId}/fortnox/connect", // POST
  STORE__FORTNOX_DISCONNECT = "store/{storeId}/fortnox", // DELETE

  USER_CONTROLLER__INVITE = "user/invite", // POST
  USER_CONTROLLER__RESET_PASSWORD = "user/reset-password/{userEmail}", // PUT
  USER_CONTROLLER__VERIFY_RESET_PASSWORD_TOKEN = "user/verify-reset-password-token", // POST
  USER_CONTROLLER__FIND_ONE_EXTENDED_BY_EMAIL = "user/{email}/details", // GET
  USER_CONTROLLER__FIND_ME_EXTENDED = "user/me/details", // GET
  USER_CONTROLLER__UPDATE_MY_LANGUAGE = "user/me/language", // PUT

  TRANSLATION__FIND_PUBLIC = "translation/public/{language}", // GET
  TRANSLATION__ADMIN_FIND_ALL = "translation/admin", // GET
  TRANSLATION__ADMIN_UPDATE = "translation/admin/{key}", // PUT

  ADMIN_CONTROLLER__MAKE_USER_ADMIN = "admin/make-admin/{userId}", // POST
  ADMIN_CONTROLLER__REMOVE_USER_AS_ADMIN = "admin/remove-admin/{userId}", // DELETE
  ADMIN_CONTROLLER__CHECK_EMAIL_VERIFIED = "admin/firebase/email-verified/{email}", // GET
  ADMIN_CONTROLLER__LIST_USERS_EMAIL_VERIFIED = "admin/firebase/users-email-verified", // GET
  ADMIN_CONTROLLER__SET_ALL_EMAIL_VERIFIED = "admin/firebase/set-all-email-verified", // POST

  AUTH_CONTROLLER__MAKE_STORE_OWNER = "auth/make-store-owner/{userId}", // POST
  AUTH_CONTROLLER__MAKE_STORE_EMPLOYEE = "auth/make-store-employee/{userId}", // POST
  AUTH_CONTROLLER__REMOVE_STORE_OWNER = "auth/remove-store-owner/{userId}", // DELETE
  AUTH_CONTROLLER__REMOVE_STORE_EMPLOYEE = "auth/remove-store-employee/{userId}", // DELETE

  TODO_CONTROLLER__FIND_ALL_BY_IS_COMPLETED = "todos/store/{storeId}", // GET
  TODO_CONTROLLER__FIND_WITH_DEADLINE_BETWEEN = "todos/between-dates/store/{storeId}", // GET
  TODO_CONTROLLER__CREATE = "todos/store/{storeId}", // POST
  TODO_CONTROLLER__UPDATE = "todos/todo/{todoId}", // PATCH
  TODO_CONTROLLER__UPDATE_POSITION = "todos/position/store/{storeId}", // PATCH
  TODO_CONTROLLER__COMPLETE = "todos/complete/store/{storeId}", // PATCH
  TODO_CONTROLLER__UNCOMPLETE = "todos/uncomplete/store/{storeId}", // PATCH
  TODO_CONTROLLER__DELETE = "todos/todo/{todoId}", // DELETE

  DELIVERY_CONTROLLER__FIND_ALL_BY_DELIVERY_STATUS = "deliverys/store/{storeId}", // GET
  DELIVERY_CONTROLLER__FIND_BETWEEN_DATES = "deliverys/between-dates/store/{storeId}", // GET
  DELIVERY_CONTROLLER__CREATE = "deliverys/store/{storeId}", // POST
  DELIVERY_CONTROLLER__DELETE = "deliverys/delivery/{deliveryId}", // DELETE
  DELIVERY_CONTROLLER__EDIT = "deliverys/delivery/{deliveryId}", // PATCH
  DELIVERY_CONTROLLER__UPDATE_POSITION = "deliverys/position/store/{storeId}", // PATCH
  DELIVERY_CONTROLLER__FIND_BY_JOB_ID = "deliverys/job/{jobId}", // GET

  POS__SAVE_ORDER = "pos/save-order/job/{jobId}", // POST
  POS__SAVE_COMBINED_ORDER = "pos/save-combined-order/store/{storeId}", // POST
  POS__SYNC_CUSTOMER = "pos/sync-customer/job/{jobId}", // POST
  POS__CAN_FIND_PRODUCTS = "pos/can-find-products/store/{storeId}", // GET
  POS__FIND_PRODUCT = "pos/find-product/store/{storeId}/ean/{ean}", // GET
  POS__CAN_SEARCH_PRODUCTS = "pos/can-search-products/store/{storeId}", // GET
  POS__CAN_FILTER_BY_STOCK = "pos/can-filter-by-stock/store/{storeId}", // GET
  POS__SEARCH_PRODUCTS = "pos/search-products/store/{storeId}/query/{query}", // GET
  POS__UPDATE_SETTINGS = "pos/settings/store/{storeId}", // PATCH

  CATALOG_PRODUCT__LIST = "catalog-product/store/{storeId}", // GET, POST
  CATALOG_PRODUCT__FIND_ONE = "catalog-product/store/{storeId}/product/{productId}", // GET, PUT, DELETE
  CATALOG_PRODUCT__FOR_PART_ACTION = "catalog-product/store/{storeId}/part/{partId}/action/{action}", // GET
  CATALOG_PRODUCT__DEFAULTS = "catalog-product/store/{storeId}/defaults", // GET

  UPSELL__CATEGORIES = "upsell/categories", // GET
  UPSELL__ADMIN_CATEGORY = "upsell/admin/categories/{categoryId}", // PUT
  UPSELL__STORE_PRODUCTS = "upsell/store/{storeId}/products", // GET, POST
  UPSELL__STORE_PRODUCT = "upsell/store/{storeId}/products/{productId}", // PUT, DELETE
  UPSELL__STORE_PRODUCT_IMAGE = "upsell/store/{storeId}/product-image", // POST
  UPSELL__STORE_DISCOUNT = "upsell/store/{storeId}/discount", // GET, PUT
  SPECTER_PRODUCT__SYNC = "specter-product/store/{storeId}/sync", // POST
  SPECTER_PRODUCT__SYNC_STATUS = "specter-product/store/{storeId}/sync-status", // GET
  SPECTER_PRODUCT__STOCK_UPDATE = "specter-product/store/{storeId}/stock-update", // POST
  CRONA_PRODUCT__CRON_SYNC = "crona-product/cron-sync", // POST
  CRONA_PRODUCT__SYNC_STATUS = "crona-product/store/{storeId}/sync-status", // GET
  SPECTER_ORDER__ORDER_UPDATE = "specter-order/store/{storeId}/order-update", // POST
  MOREFLO_RECEIPT__RECEIPT_CREATED = "moreflo-receipt/store/{storeId}/receipt-created", // POST
  FORTNOX_ORDER__CRON_SYNC_DELIVERIES = "fortnox-order/cron/sync-deliveries", // POST - Cron auth

  CHECK_IN__SEND_CODE = "check-in/send-code/store/{storeSlug}", // POST
  CHECK_IN__VERIFY_CODE = "check-in/verify-code/store/{storeSlug}", // POST
  CHECK_IN__SUBMIT = "check-in/submit/store/{storeSlug}", // POST
  CHECK_IN__GET_STORE_DATA = "check-in/store-data/store/{storeSlug}", // GET
  CHECK_IN__GET_AVAILABLE_DATES = "check-in/available-dates/store/{storeSlug}", // GET
  CHECK_IN__FIND_BY_JOB = "check-in/job/{jobId}", // GET
  CHECK_IN__VERIFY_CODE_FOR_EVENT = "check-in/event/verify-code/store/{storeSlug}", // POST
  CHECK_IN__SUBMIT_FOR_EVENT = "check-in/event/submit/store/{storeSlug}", // POST
  CHECK_IN__GET_STORE_DATA_FOR_EVENT = "check-in/event/store-data/store/{storeSlug}", // GET
  CHECK_IN__FIND_BIKES = "check-in/bikes/store/{storeSlug}", // GET

  // Damper Service
  DAMPER_BRAND__FIND_ALL = "damper-brand", // GET
  DAMPER_BRAND__SAVE = "damper-brand", // POST

  STORE_SUPPORTED_DAMPER_BRAND__FIND_ALL = "store-supported-damper-brand/store/{storeId}", // GET
  STORE_SUPPORTED_DAMPER_BRAND__ADD = "store-supported-damper-brand/store/{storeId}", // POST
  STORE_SUPPORTED_DAMPER_BRAND__REMOVE = "store-supported-damper-brand/store/{storeId}/brand/{damperBrandId}", // DELETE

  DAMPER_SERVICE_PRICE__FIND_ALL = "damper-service-price/store/{storeId}", // GET
  DAMPER_SERVICE_PRICE__UPSERT = "damper-service-price/store/{storeId}", // PUT
  DAMPER_SERVICE_PRICE__DELETE = "damper-service-price/{priceId}", // DELETE

  DAMPER_SERVICE_ACTION_NAME__FIND_ALL = "damper-service-action-name/store/{storeId}", // GET
  DAMPER_SERVICE_ACTION_NAME__UPSERT = "damper-service-action-name/store/{storeId}", // PUT
  DAMPER_SERVICE_ACTION_NAME__DELETE = "damper-service-action-name/{nameId}", // DELETE

  DAMPER_BOOKING_INFO__FIND_BY_JOB = "damper-booking-info/job/{jobId}", // GET

  // Message Variables
  MESSAGE_VARIABLE__RESOLVE = "message-variable/job/{jobId}/resolved", // GET
  MESSAGE_VARIABLE__RESOLVE_FOR_STORE = "message-variable/store/{storeId}/resolved", // GET
  MESSAGE_VARIABLE__RESOLVE_FOR_STORE_CUSTOMER = "message-variable/store-customer/{storeCustomerId}/resolved", // GET

  // Custom Message Variants
  CUSTOM_MESSAGE_VARIANT__CREATE = "custom-message-variant/store/{storeId}", // POST
  CUSTOM_MESSAGE_VARIANT__FIND_BY_STORE = "custom-message-variant/store/{storeId}", // GET
  CUSTOM_MESSAGE_VARIANT__UPDATE = "custom-message-variant/{variantId}", // PATCH
  CUSTOM_MESSAGE_VARIANT__DELETE = "custom-message-variant/{variantId}", // DELETE
  CUSTOM_MESSAGE_VARIANT__GET_COMPOSED = "custom-message-variant/{variantId}/job/{jobId}/composed", // GET
  CUSTOM_MESSAGE_VARIANT__GET_COMPOSED_FOR_STORE_CUSTOMER = "custom-message-variant/{variantId}/store-customer/{storeCustomerId}/composed", // GET

  // Service Event
  SERVICE_EVENT__CREATE = "service-event/store/{storeId}", // POST
  SERVICE_EVENT__FIND_ALL_BY_STORE = "service-event/store/{storeId}", // GET
  SERVICE_EVENT__FIND_ONE = "service-event/{eventId}", // GET
  SERVICE_EVENT__UPDATE = "service-event/{eventId}", // PATCH
  SERVICE_EVENT__DELETE = "service-event/{eventId}", // DELETE
  SERVICE_EVENT__PUBLISH = "service-event/{eventId}/publish", // POST
  SERVICE_EVENT__DUPLICATE = "service-event/{eventId}/duplicate", // POST
  SERVICE_EVENT__SAVE_NOTE = "service-event/{eventId}/note", // PUT
  SERVICE_EVENT__UPLOAD_IMAGE = "service-event/{eventId}/image", // POST
  SERVICE_EVENT__FIND_JOBS = "service-event/{eventId}/jobs", // GET
  SERVICE_EVENT__FIND_PARTICIPANTS = "service-event/{eventId}/participants", // GET
  SERVICE_EVENT__FIND_ONE_PUBLIC = "service-event/public/{eventId}", // GET - No auth
  SERVICE_EVENT__BOOK_AS_CUSTOMER = "service-event/{eventId}/book", // POST - No auth
  SERVICE_EVENT__GET_EMAIL_PREVIEW = "service-event/email-preview/job/{jobId}", // GET

  // Connected Store
  CONNECTED_STORE__FIND_BY_STORE = "connected-store/store/{storeSlug}", // GET - No auth

  // Calendar
  CALENDAR__BETWEEN_DATES = "calendar/store/{storeId}", // GET
  CALENDAR__COUNTS = "calendar/counts/store/{storeId}", // GET
  CALENDAR__AGGREGATES = "calendar/aggregates/store/{storeId}", // GET
  CALENDAR__JOB_HOVER = "calendar/job/{jobId}/hover", // GET

  ALFRED__SUBMIT_CONTACT_FORM = "alfred/contact-form", // POST - No auth
  ALFRED__SUBMIT_TOOLS_REQUEST = "alfred/tools-request", // POST - No auth
  ALFRED__PRICING = "alfred/pricing", // GET - No auth
  ALFRED__ADMIN_PRICING_MODULES = "alfred/admin/pricing/modules", // POST
  ALFRED__ADMIN_PRICING_MODULE = "alfred/admin/pricing/modules/{moduleId}", // PATCH, DELETE
  ALFRED__ADMIN_PRICING_PACKAGES = "alfred/admin/pricing/packages", // POST
  ALFRED__ADMIN_PRICING_PACKAGE = "alfred/admin/pricing/packages/{packageId}", // PATCH, DELETE
  ALFRED__ADMIN_PRICING_IMAGES = "alfred/admin/pricing/images", // POST
  ALFRED__STORE_OFFERS = "alfred/offers/{storeSlug}", // GET - No auth
  ALFRED__STORE_OFFER_PDF = "alfred/offers/{storeSlug}/{offerId}/pdf", // GET - No auth
  ALFRED__ADMIN_STORE_OFFERS = "alfred/admin/offers/{storeSlug}", // POST
  ALFRED__ADMIN_STORE_OFFER = "alfred/admin/offers/{storeSlug}/{offerId}", // PATCH, DELETE

  // Service Reminder
  SERVICE_REMINDER__CRON_POPULATE = "service-reminder/cron/populate", // POST - Cron auth
  SERVICE_REMINDER__FIND_BY_STORE = "service-reminder/store/{storeId}", // GET
  SERVICE_REMINDER__SEND_BATCH = "service-reminder/store/{storeId}/send", // POST
  SERVICE_REMINDER__DISMISS_BATCH = "service-reminder/store/{storeId}/dismiss", // POST
  SERVICE_REMINDER__OPT_OUT = "service-reminder/opt-out/{emailId}", // POST - No auth
  SERVICE_REMINDER__GET_SETTINGS = "service-reminder/settings/store/{storeId}", // GET
  SERVICE_REMINDER__UPDATE_SETTINGS = "service-reminder/settings/store/{storeId}", // PATCH
  SERVICE_REMINDER__UPSERT_MODULE = "service-reminder/settings/store/{storeId}/module", // PUT
  SERVICE_REMINDER__DELETE_MODULE = "service-reminder/settings/store/{storeId}/module/{moduleId}", // DELETE
  SERVICE_REMINDER__UPLOAD_IMAGE = "service-reminder/settings/store/{storeId}/image", // POST
  SERVICE_REMINDER__GET_NEW_PROPOSAL = "service-reminder/new-proposal/job/{jobId}", // GET - No auth
  SERVICE_REMINDER__GET_JOB_EMAIL_HTML = "service-reminder/jobs/{jobId}/email-html", // GET - No auth
  SERVICE_REMINDER__POPULATE_STORE = "service-reminder/store/{storeId}/populate", // POST
  SERVICE_REMINDER__PREVIEW_EMAIL = "service-reminder/store/{storeId}/preview/{emailId}", // POST (re-generates pending emails)

  // Service Day Reminder (sent the day before the customer's service day)
  SERVICE_DAY_REMINDER__CRON_SEND = "service-day-reminder/cron/send", // POST - Cron auth
  PICKUP_REMINDER__CRON_SEND = "pickup-reminder/cron/send", // POST - Cron auth
  STATS__CRON_SYNC_LEAD_TIMES = "stats/cron/sync-lead-times", // POST - Cron auth
  STATS__CRON_BACKFILL_JOB_LEAD_TIMES = "stats/cron/backfill-job-lead-times", // POST - Cron auth
  STATS__CRON_BACKFILL_CUSTOMER_CHAT_LEAD_TIMES = "stats/cron/backfill-customer-chat-lead-times", // POST - Cron auth
  PROPOSAL_REMINDER__CRON_SEND = "proposal-reminder/cron/send", // POST - Cron auth

  CYCLIST_ACCOUNT__REGISTER = "cyclist-account/register", // POST
  CYCLIST_ACCOUNT__ME = "cyclist-account/me", // GET
  CYCLIST_ACCOUNT__DELETE_ME = "cyclist-account/me", // DELETE
  CYCLIST_ACCOUNT__SEND_PHONE_VERIFICATION_CODE = "cyclist-account/send-phone-verification-code", // POST
  CYCLIST_ACCOUNT__VERIFY_PHONE = "cyclist-account/verify-phone", // POST
  CYCLIST_ACCOUNT__UPDATE_PHONE_NUMBER = "cyclist-account/update-phone-number", // POST
  CYCLIST_ACCOUNT__CANCEL_PHONE_CHANGE = "cyclist-account/cancel-phone-change", // POST
  CYCLIST_ACCOUNT__SEND_EMAIL_VERIFICATION = "cyclist-account/send-email-verification", // POST
  CYCLIST_ACCOUNT__VERIFY_EMAIL = "cyclist-account/verify-email", // POST
  CYCLIST_ACCOUNT__CREATE_BIKE = "cyclist-account/bikes", // POST
  CYCLIST_ACCOUNT__UPDATE_BIKE = "cyclist-account/bikes/{bikeId}", // PATCH
  CYCLIST_ACCOUNT__DELETE_BIKE = "cyclist-account/bikes/{bikeId}", // DELETE
  CYCLIST_ACCOUNT__UPDATE_NOTIFICATION_SETTINGS = "cyclist-account/notification-settings", // PATCH
  CYCLIST_ACCOUNT__UPDATE_PROFILE = "cyclist-account/profile", // PATCH
  CYCLIST_ACCOUNT__UPDATE_EMAIL = "cyclist-account/email", // PATCH
  CYCLIST_ACCOUNT__JOBS = "cyclist-account/jobs", // GET
  CYCLIST_ACCOUNT__PARTS = "cyclist-account/parts", // GET
  CYCLIST_ACCOUNT__ADD_BIKE_PART = "cyclist-account/bikes/{bikeId}/parts", // POST
  CYCLIST_ACCOUNT__DELETE_BIKE_PART = "cyclist-account/bike-parts/{bikePartId}", // DELETE
  CYCLIST_ACCOUNT__UPLOAD_BIKE_IMAGE = "cyclist-account/bikes/{bikeId}/images", // POST
  CYCLIST_ACCOUNT__DELETE_BIKE_IMAGE = "cyclist-account/bike-images/{imageId}", // DELETE
  CYCLIST_ACCOUNT__UPLOAD_BIKE_DOCUMENT = "cyclist-account/bikes/{bikeId}/documents", // POST
  CYCLIST_ACCOUNT__DELETE_BIKE_DOCUMENT = "cyclist-account/bike-documents/{documentId}", // DELETE
  CYCLIST_ACCOUNT__ADD_FAVORITE_STORE = "cyclist-account/favorite-stores/{storeId}", // POST
  CYCLIST_ACCOUNT__REMOVE_FAVORITE_STORE = "cyclist-account/favorite-stores/{storeId}", // DELETE
  CYCLIST_ACCOUNT__REORDER_FAVORITE_STORES = "cyclist-account/favorite-stores/reorder", // PATCH
  CYCLIST_ACCOUNT__RESOLVE_LOGIN = "cyclist-account/resolve-login", // POST

  BIKE_FOR_SALE_CONTROLLER__CREATE = "bike-for-sale/store/{storeId}", // POST
  BIKE_FOR_SALE_CONTROLLER__FIND_MANY_BY_STORE_ID = "bike-for-sale/store/{storeId}", // GET
  BIKE_FOR_SALE_CONTROLLER__FIND_ONE_BY_ID = "bike-for-sale/{bikeId}", // GET
  BIKE_FOR_SALE_CONTROLLER__UPDATE = "bike-for-sale/{bikeId}", // PATCH
  BIKE_FOR_SALE_CONTROLLER__UPDATE_STATUS = "bike-for-sale/{bikeId}/status", // PATCH
  BIKE_FOR_SALE_CONTROLLER__DELETE = "bike-for-sale/{bikeId}", // DELETE
  BIKE_FOR_SALE_CONTROLLER__SUBMIT_INSPECTION = "bike-for-sale/{bikeId}/inspection", // POST
  BIKE_FOR_SALE_CONTROLLER__FIND_INSPECTION = "bike-for-sale/{bikeId}/inspection", // GET
  BIKE_FOR_SALE_CONTROLLER__FIND_INSPECTION_PROTOCOL = "bike-for-sale/{bikeId}/inspection/protocol", // GET
  BIKE_FOR_SALE_CONTROLLER__GET_INSPECTION_PREREQS = "bike-for-sale/{bikeId}/inspection/prerequisites", // GET
  BIKE_FOR_SALE_CONTROLLER__PROPOSAL_PREVIEW = "bike-for-sale/{bikeId}/inspection/proposal-preview", // POST
  BIKE_FOR_SALE_CONTROLLER__CREATE_ACCOUNTING_RECORD = "bike-for-sale/{bikeId}/accounting-record", // POST
  BIKE_FOR_SALE_CONTROLLER__UPDATE_INSPECTION_PRODUCT = "bike-for-sale/{bikeId}/inspection/products/{productId}", // PATCH
  BIKE_FOR_SALE_CONTROLLER__DELETE_INSPECTION_PRODUCT = "bike-for-sale/{bikeId}/inspection/products/{productId}", // DELETE
  BIKE_FOR_SALE_CONTROLLER__SUBMIT_LISTING = "bike-for-sale/{bikeId}/listing", // POST (multipart)
  BIKE_FOR_SALE_CONTROLLER__PUBLISH = "bike-for-sale/{bikeId}/publish", // POST
  BIKE_FOR_SALE_CONTROLLER__SET_JULO_PUBLICATION = "bike-for-sale/{bikeId}/julo-publication", // PATCH
  BIKE_FOR_SALE_CONTROLLER__MARK_AS_SOLD = "bike-for-sale/{bikeId}/mark-as-sold", // POST
  BIKE_FOR_SALE_CONTROLLER__MARK_AS_HANDED_OVER = "bike-for-sale/{bikeId}/mark-as-handed-over", // POST
  BIKE_FOR_SALE_CONTROLLER__AWAITING_HANDOVER_COUNT = "bike-for-sale/store/{storeId}/awaiting-handover-count", // GET
  BIKE_FOR_SALE_CONTROLLER__MOVE_TARGETS = "bike-for-sale/{bikeId}/move-targets", // GET
  BIKE_FOR_SALE_CONTROLLER__MOVE_TO_STORE = "bike-for-sale/{bikeId}/move", // POST

  SELF_BILLING_INVOICE__FIND_MANY_BY_STORE = "self-billing-invoice/store/{storeId}", // GET
  SELF_BILLING_INVOICE__DOWNLOAD_PDF = "self-billing-invoice/{selfBillingInvoiceId}/pdf", // GET

  BIKE_FOR_SALE_DEFAULT_MANUAL_ACTION__CREATE = "bike-for-sale-default-manual-action/store/{storeId}", // POST
  BIKE_FOR_SALE_DEFAULT_MANUAL_ACTION__FIND_MANY_FOR_STORE = "bike-for-sale-default-manual-action/store/{storeId}", // GET
  BIKE_FOR_SALE_DEFAULT_MANUAL_ACTION__UPDATE = "bike-for-sale-default-manual-action/store/{storeId}/{actionId}", // PUT
  BIKE_FOR_SALE_DEFAULT_MANUAL_ACTION__DELETE = "bike-for-sale-default-manual-action/store/{storeId}/{actionId}", // DELETE

  MARKETPLACE__BIKES_FIND_ALL = "marketplace/bikes", // GET (public)
  // Distinct path (not `marketplace/bikes/...`) so it never collides with the
  // `:bikeId` param route below.
  MARKETPLACE__BIKES_AVAILABILITY = "marketplace/bikes-availability", // GET (public)
  MARKETPLACE__BIKES_AVAILABILITY_FOR_STORE = "marketplace/bikes-availability/store/{storeSlug}", // GET (public)
  MARKETPLACE__BIKE_FIND_ONE = "marketplace/bikes/{bikeId}", // GET (public)
  MARKETPLACE__BIKE_CHECKOUT_CREATE = "marketplace/bikes/{bikeId}/checkout", // POST (public)
  MARKETPLACE__BIKE_CHECKOUT_STATUS = "marketplace/bikes/{bikeId}/checkout/{sessionId}", // GET (public)
  MARKETPLACE__BIKE_CHECKOUT_CANCEL = "marketplace/bikes/{bikeId}/checkout/{sessionId}/cancel", // POST (public)

  STRIPE_WEBHOOK__EVENT = "stripe-webhook", // POST (Stripe HMAC signature, no @Auth)
  FORTNOX__OAUTH_CALLBACK = "fortnox/callback", // GET (browser redirect from Fortnox; single-use state + PKCE, no @Auth)

  STORAGE_LOCATION_CONTROLLER__CREATE = "storage-location/store/{storeId}", // POST
  STORAGE_LOCATION_CONTROLLER__FIND_MANY_FOR_STORE = "storage-location/store/{storeId}", // GET
  STORAGE_LOCATION_CONTROLLER__UPDATE = "storage-location/{storageLocationId}", // PUT
  STORAGE_LOCATION_CONTROLLER__DELETE = "storage-location/{storageLocationId}", // DELETE
  STORAGE_LOCATION_CONTROLLER__GET_DEFAULT = "storage-location/store/{storeId}/default", // GET
  STORAGE_LOCATION_CONTROLLER__SET_DEFAULT = "storage-location/store/{storeId}/default", // PUT

  VSL__ADMIN_FIND_ALL = "vsl/admin", // GET
  VSL__ADMIN_CREATE = "vsl/admin", // POST
  VSL__ADMIN_FIND_ONE = "vsl/admin/{vslId}", // GET
  VSL__ADMIN_UPDATE = "vsl/admin/{vslId}", // PUT
  VSL__ADMIN_STATS = "vsl/admin/{vslId}/stats", // GET
  VSL__ADMIN_SUBMISSIONS = "vsl/admin/{vslId}/submissions", // GET
  VSL__ADMIN_LINKS = "vsl/admin/{vslId}/links", // GET
  VSL__ADMIN_CREATE_LINKS = "vsl/admin/{vslId}/links", // POST
  VSL__ADMIN_CREATE_CUSTOM_LINK = "vsl/admin/{vslId}/custom-links", // POST
  VSL__ADMIN_LINK_VIEWERS = "vsl/admin/link/{linkId}/viewers", // GET
  VSL__ADMIN_EMAIL_HTML = "vsl/admin/{vslId}/email-html", // GET (?linkId=)
  VSL__ADMIN_CREATE_VERSION = "vsl/admin/{vslId}/versions", // POST
  VSL__ADMIN_VERSION_UPLOADED = "vsl/admin/version/{versionId}/uploaded", // POST
  VSL__ADMIN_UPDATE_VERSION = "vsl/admin/version/{versionId}", // PUT
  VSL__ADMIN_MAKE_VERSION_LIVE = "vsl/admin/version/{versionId}/live", // POST
  VSL__ADMIN_VERSION_STATS = "vsl/admin/version/{versionId}/stats", // GET
  VSL__ADMIN_UPLOAD_VERSION_THUMBNAIL = "vsl/admin/version/{versionId}/thumbnail", // POST (multipart "image")
  VSL__ADMIN_REMOVE_VERSION_THUMBNAIL = "vsl/admin/version/{versionId}/thumbnail", // DELETE
  VSL__BUNNY_WEBHOOK = "vsl/bunny-webhook", // POST (Bunny HMAC signature, no @Auth)
  VSL__START_SESSION = "vsl/session", // POST (public)
  VSL__RECORD_PROGRESS = "vsl/session/{sessionId}/progress", // POST (public)
  VSL__RECORD_CTA_CLICK = "vsl/session/{sessionId}/cta-click", // POST (public)
  VSL__SUBMIT_FORM = "vsl/session/{sessionId}/form", // POST (public)
  VSL__OEMBED = "vsl/oembed", // GET (public, ?url=, served on video.julo.se for link previews)
}
